import { FC, memo } from 'react'
import UtxoFeeRate from './UtxoFeeRate'
import EVMLegacyFeeRate from './EVMLegacyFeeRate'
import EIP1559FeeRate from './EIP1559FeeRate'

import { FeeLevelModel, FeeRateDto } from '@/services/apis/tx/models'
import FilFeeRate from './FilFeeRate'
import SuiFeeRate from './SuiFeeRate'
import AptosFeeRate from './AptosFeeRate'

interface CustomFeePanelProps {
  setCustomError: (error: boolean) => void
  customFeeRate: FeeRateDto
  setCustomFeeRate: (val: FeeRateDto) => void
  coinImplTag?: string
  isSupportEIP1559: boolean
  feeLevelModel: FeeLevelModel
  coinKey: string
  isSpeed: boolean
}

const CustomFeePanel: FC<CustomFeePanelProps> = ({
  setCustomError,
  customFeeRate,
  setCustomFeeRate,
  coinImplTag,
  isSupportEIP1559,
  feeLevelModel,
  coinKey,
  isSpeed,
}) => {
  const params = {
    unit: feeLevelModel?.feeUnit,
    coinKey,
    value: customFeeRate,
    mini: feeLevelModel?.minFeeRate,
    max: feeLevelModel?.highFeeRate,
    isSpeed,
    onChangeValue: (error: boolean, feeRateDto: FeeRateDto) => {
      setCustomError(error)
      setCustomFeeRate(feeRateDto)
    },
  }
  switch (coinImplTag) {
    case 'utxo':
      return <UtxoFeeRate {...params} />
    case 'eth':
      if (isSupportEIP1559) {
        return <EIP1559FeeRate {...params} />
      }
      return <EVMLegacyFeeRate {...params} />
    case 'fil':
      return <FilFeeRate {...params} />
    case 'sui':
      return <SuiFeeRate {...params} />
    case 'aptos':
      return <AptosFeeRate {...params} />
    default:
      return null
  }
}

export default memo(CustomFeePanel)
